// extracted by mini-css-extract-plugin
module.exports = {"payPalButtonsTopMargin":"src-container-PaymentMethodSelection-PaymentMethodSelectionContainer-index-module__payPalButtonsTopMargin--1cFzw"};